const examples = [
  {
    name: "Basic",
    doc: require("./BasicExample.docs.js").default,
    img: "/images/components/topnav.png",
    section: "Examples",
  },
   {
    name: "PPDAF",
    doc: require("./ppdaf/index.docs.js").default,
    img: "/images/components/topnav.png",
    section: "PPDAF",
  },
];

export default examples;
